export enum TenantType {
  shipper = 'shipper',
  haulier = 'haulier',
  accepted_haulier = 'accepted',
  invited_haulier = 'invited',
}
